import React from "react";

import { Grid } from "@mui/material";

import SkeletonComponent from "../../../../../components/Generic/Skeleton";
import useStyles from "./styles";

const SkeletonCommunication = () => {
  const classes = useStyles();

  return (
    <Grid container direction="row" spacing={3}>
      <Grid item xs={6}>
        <SkeletonComponent classesName={classes.skeleton} isLoading>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={6}>
        <SkeletonComponent classesName={classes.skeleton} isLoading>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={6}>
        <SkeletonComponent classesName={classes.skeleton} isLoading>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={6}>
        <SkeletonComponent classesName={classes.skeleton} isLoading>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={6}>
        <SkeletonComponent classesName={classes.skeleton} isLoading>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={6}>
        <SkeletonComponent classesName={classes.skeleton} isLoading>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={6}>
        <SkeletonComponent classesName={classes.skeleton} isLoading>
          <div />
        </SkeletonComponent>
      </Grid>
      <Grid item xs={6}>
        <SkeletonComponent classesName={classes.skeleton} isLoading>
          <div />
        </SkeletonComponent>
      </Grid>
    </Grid>
  );
};

export default SkeletonCommunication;
